export default function WorldScreen({world,progress,onSelectLesson,onBack,tier}){
  const dark = tier === "master";
  const doneCount=world.lessons.filter((_,i)=>progress[`${world.id}-${i}`]).length;
  return(
    <div style={{fontFamily:"Nunito",minHeight:"100vh",background:dark?"#0f172a":world.bg,paddingBottom:100}}>
      <div style={{background:dark?`linear-gradient(135deg,#1e3a5f,#0f172a)`:`linear-gradient(135deg,${world.color},${world.dark})`,padding:"18px 16px 24px",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:-25,right:-15,fontSize:110,opacity:0.1}}>{world.emoji}</div>
        <button onClick={onBack} className="btn-bounce"
          style={{background:"#ffffff30",border:"2px solid #ffffff50",borderRadius:12,
            padding:"6px 14px",fontSize:13,fontWeight:800,color:"#fff",cursor:"pointer",marginBottom:12,display:"block"}}>
          ← Back to Map
        </button>
        <div style={{display:"flex",gap:14,alignItems:"center"}}>
          {!dark && (
            <div style={{fontSize:54,animation:"float 3s infinite",lineHeight:1,flexShrink:0}}>🐿️</div>
          )}
          <div>
            <div style={{fontSize:25,fontWeight:900,color:"#fff",fontFamily:"Fredoka One"}}>{world.label}</div>
            {!dark && (
              <div style={{fontSize:13,color:"#ffffff99",fontWeight:700}}>Guide: Stash 🐿️</div>
            )}
            <div style={{fontSize:14,color:dark?"#94a3b8":"#fff",fontWeight:800,marginTop:3}}>⭐ {doneCount}/{world.lessons.length} lessons done</div>
          </div>
        </div>
      </div>

      <div style={{padding:"20px 16px",display:"flex",flexDirection:"column",gap:12,position:"relative"}}>
        <div style={{position:"absolute",left:42,top:0,bottom:0,width:4,background:dark?"#334155":`${world.color}33`,borderRadius:4,pointerEvents:"none"}}/>
        {world.lessons.map((lesson,i)=>{
          const isDone=progress[`${world.id}-${i}`];
          return(
            <div key={i} style={{display:"flex",gap:14,alignItems:"center",position:"relative",zIndex:1}}>
              <div style={{width:44,height:44,borderRadius:"50%",flexShrink:0,
                background:isDone?`linear-gradient(135deg,${world.color},${world.dark})`:dark?"#1e293b":`${world.color}18`,
                border:`3px solid ${isDone?world.color:dark?"#334155":world.color+"55"}`,
                display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,
                boxShadow:isDone?`0 4px 14px ${world.color}55`:"0 2px 6px #0001",
                animation:isDone?"starSpin 0.6s ease-out":"none"}}>
                {isDone?"⭐":"▶"}
              </div>
              <button onClick={()=>onSelectLesson(i)}
                className="btn-bounce"
                style={{flex:1,
                  background:dark?(isDone?`${world.color}18`:"#1e293b"):(isDone?`${world.color}18`:"#fff"),
                  border:`2.5px solid ${isDone?world.color:dark?"#334155":world.color+"55"}`,
                  borderRadius:18,padding:"14px 16px",cursor:"pointer",
                  textAlign:"left",boxShadow:dark?"0 3px 10px #00000044":"0 3px 10px #0001"}}>
                <div style={{fontSize:16,fontWeight:900,color:dark?"#f1f5f9":world.dark,fontFamily:"Fredoka One"}}>{lesson.title}</div>
                <div style={{fontSize:12,color:dark?"#6366f1":world.color,fontWeight:700,marginTop:2}}>
                  {isDone?"✅ Completed! Replay anytime":"Tap to start →"}
                </div>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
